import { GetServerSideProps } from 'next';
import React from 'react';
import { ContextContainer } from '../../components/AppContext';
import InspirationWithRelatedProductsPage from '../../components/Inspiration/InspirationWithRelatedProductsPage';
import Layout from '../../components/Layout';
import { IInspiration } from '../../interfaces';
import { getInspirationById } from '../../services/inspirations';
import logger from '../../services/serverLogger';
import { getServerSideTranslations } from '../../services/translations';
import { headerPropsForInspiration } from '../../utils/htmlHeader';
import Error from '../_error';
import { getActivatedSceneById } from '../../services/storybook';

const Inspiration = ({ inspiration }: { inspiration?: IInspiration }) => {
  if (!inspiration) return <Error hasGetInitialPropsRun={true} err={null} />;
  return (
    <Layout headerProps={headerPropsForInspiration(inspiration)}>
      <ContextContainer>
        <InspirationWithRelatedProductsPage inspiration={inspiration} />
      </ContextContainer>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const id: string = context.params.id as string;
  let inspiration = null;
  try {
    inspiration = await getInspirationById(decodeURIComponent(id));
    const { type, sceneId } = inspiration;
    if (type === 'scene' && sceneId) {
      const scene = await getActivatedSceneById(sceneId);
      inspiration['scene'] = scene;
    }
  } catch (error) {
    logger.error({ error }, `getInspirationById failed for id ${id}`);
  }
  return {
    props: {
      ...(await getServerSideTranslations(context.query?.language as string)),
      inspiration
    }
  };
};

export default Inspiration;
